module.exports = __webpack_public_path__ + "static/media/ac-edit.83fdc7d6.svg";